export default __webpack_public_path__ + "1f57079b1f044d7fa09f2ba3c3fd2452.svg";